export var PointSizeType;
(function (PointSizeType) {
    PointSizeType[PointSizeType["FIXED"] = 0] = "FIXED";
    PointSizeType[PointSizeType["ADAPTIVE"] = 1] = "ADAPTIVE";
    PointSizeType[PointSizeType["ADAPTIVE_BY_DISTANCE"] = 2] = "ADAPTIVE_BY_DISTANCE";
})(PointSizeType || (PointSizeType = {}));
